export default __webpack_public_path__ + "c0a598bc21105e34aba0b8944c63e289.png";